module.exports = __webpack_public_path__ + "img/loading.b55a3a21.gif";